import epicTracking from 'epic-tracking';
import React from 'react';
import VisibilitySensor from 'react-visibility-sensor';

import {VBucksImage} from './components';
import {
  StyledVBucksThreeColumnWrapper,
  StyledVBucksThreeColumnImgContainer,
  StyledVbucksContentCard,
} from './components/VBucksStyledComponents';

interface CmsData {
  imgLeft: string;
  imgRight: string;
  header: string;
  textContent: string;
  mobileImage: string;
}

interface Props {
  mobile: boolean;
  tablet: boolean;
  data: CmsData;
}

interface VBucksCardProps {
  title: string;
  desc: string;
}

const VBucksCard = ({title, desc}: VBucksCardProps) => {
  return (
    <div>
      <h2>{title}</h2>
      <p>{desc}</p>
    </div>
  );
};

const VBucksSectionThreeColumn = ({data, mobile, tablet}: Props) => {
  const [visible, setVisibility] = React.useState(false);

  const setSectionVisibility = React.useCallback(
    (visibility) => {
      setVisibility(visibility);
      if (visibility) {
        epicTracking.trackEvent('Interaction', {
          interactionType: 'scrollViewSection',
          eventCategory: 'BattlePass VBucks Section',
          eventAction: 'VBucksSection-inView',
        });
      }
    },
    [setVisibility]
  );

  return (
    <VisibilitySensor
      active={!visible}
      onChange={setSectionVisibility}
      partialVisibility
      minTopValue={0}>
      <StyledVBucksThreeColumnWrapper>
        {!mobile && (
          <StyledVBucksThreeColumnImgContainer direction="left">
            <VBucksImage src={data.imgLeft} alt={''} />
          </StyledVBucksThreeColumnImgContainer>
        )}
        <StyledVbucksContentCard>
          <VBucksCard title={data.header} desc={data.textContent} />
        </StyledVbucksContentCard>
        <StyledVBucksThreeColumnImgContainer direction="right">
          <VBucksImage src={mobile ? data.mobileImage : data.imgRight} alt={''} />
        </StyledVBucksThreeColumnImgContainer>
      </StyledVBucksThreeColumnWrapper>
    </VisibilitySensor>
  );
};

export default VBucksSectionThreeColumn;
